import { Component,Input, OnInit } from '@angular/core';
import { IonItemSliding } from '@ionic/angular';
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { TranslateService } from '@ngx-translate/core';
import { BeerInfo } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BeerDetailPage_PATH } from '../../app/app-constants';

// TODO this component needs to be removed 
/**
 * Generated class for the FoundBeerComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'found-beer',
  templateUrl: 'found-beer.html',
  styleUrls: ['./found-beer.scss'],
  standalone: false,
})
export class FoundBeerComponent implements OnInit {
  @Input() beer : any;
  @Input() rating: any;
  @Input() removalId: any;


  constructor(
    private router: Router,
    private bhutil: BhutilProvider,
    private translateService: TranslateService,
    private refdata: RefdataProvider,
    private events: AppEventService
  ) {

  }

  ngOnInit(){
  }

  showBeerDetail(beer: any) {
    console.log("TODO: show details for beer " + this.bhutil.stringify(beer));
    console.log("beer id is " + beer.id);
    let beerObj = {"beer": beer};
    //navigate to the detail screen, with the info preloaded
    this.router.navigate([ BeerDetailPage_PATH ], { state: { data: {
        'beer': beerObj,
        'sourcetype': 'highest-rated-beers',
        'sourceID': 1
      }}});
    //sourceID 1 == HIGHEST-RATED-BEERS
  }

  getValueStr() {
    let v = this.beer.abv;
    if (v >= 0) {
      v = Math.round(v * 10) / 10;
      v += "%";
      return v + " " + this.translateService.instant("ADDBEER.ABV");
    } else {
      return "-% " + this.translateService.instant("ADDBEER.ABV")
    }
  }

  getImageUrl() {
    //console.log("getImageUrl for beer id: " + b.beer.id);

    if (this.beer.logo !== undefined && this.beer.logo != null) {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + this.beer.logo;
      //console.log("LOGO - using beer logo: " + logoUrlBeer);
      return logoUrlBeer;
    } else if (this.beer.brewery.logo !== undefined && this.beer.brewery.logo != null) {
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + this.beer.brewery.logo;
      //console.log("LOGO - using brewery logo: " + logoUrlBrewery);
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      //console.log("LOGO - using placeholder logo (no_logo: " + logoNoLogo);
      return logoNoLogo;
    }
  }

  getDropSize(dropNr) {
    if (this.rating) {
      if (dropNr <= this.rating) {
        return "assets/svg/icon_bh_" + "full" + ".svg";
      } else if (dropNr == this.rating + 0.5) {
        return "assets/svg/icon_bh_" + "half" + ".svg";
      } else {
        return "assets/svg/icon_bh_" + "empty" + ".svg";
      }
    }
  }

  delete(item: IonItemSliding) {
    this.events.publish("delete:beer", {beer: this.beer, item: item, removalId: this.removalId});
  }
}
